import { render, staticRenderFns } from "./CollectionItem.vue?vue&type=template&id=de31d196&scoped=true&"
import script from "./CollectionItem.vue?vue&type=script&lang=js&"
export * from "./CollectionItem.vue?vue&type=script&lang=js&"
import style0 from "./CollectionItem.vue?vue&type=style&index=0&id=de31d196&lang=scss&scoped=true&"
import style1 from "./CollectionItem.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de31d196",
  null
  
)

export default component.exports